import { useContext } from 'react';
import { PermissionsContext, FormMode } from '../contexts/PermissionsContext';

/** Access the full permissions context (hasPermission, isLoading, refetch). */
export function usePermissions() {
  return useContext(PermissionsContext);
}

/**
 * Convenience hook — returns a single boolean for a specific menu + formMode.
 * Useful for inline button / field guards:
 *   const canAdd = useHasPermission('stock.inward', 'add');
 */
export function useHasPermission(menuCode: string, mode: FormMode): boolean {
  const { hasPermission } = useContext(PermissionsContext);
  return hasPermission(menuCode, mode);
}
